import React, { useState } from "react";
import axios from "axios";
import "./ContactUs.css";
import { useNavigate } from "react-router-dom";
import cross from "../../Images/cross.png";
import Footer from "./footer";
import tick from "../../Operator/SVGs/tick.svg";
import insta from "../../Operator/SVGs/insta.svg";
import twitter from "../../Operator/SVGs/twitter.svg";
import linkedin from "../../Operator/SVGs/linkedin.svg";
import Mail from "../../Operator/SVGs/Mail.svg";
import Call from "../../Operator/SVGs/Call.svg";
import Location from "../../Operator/SVGs/Location.svg";
import NavBar from "./NavBarNew";

const ContactUsLanding = () => {
  const navigate = useNavigate();

  const [isConfirmationOpen, setIsConfirmationOpen] = useState(false);
  const [isErrorOpen, setIsErrorOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [formValues, setFormValues] = useState({
    firstName: "",
    lastName: "",
    email: "",
    subject: "",
    helpMessage: "",
  });
  const handleConfirmationClose = () => {
    setFormValues({ ...formValues });
    setIsConfirmationOpen(false);
  };

  const handleErrorClose = () => {
    setIsErrorOpen(false);
    // onClose();
  };
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues({ ...formValues, [name]: value });
  };
  const handleCancel = () => {
    const { firstName, lastName, email, subject, helpMessage } = formValues;

    if (firstName || lastName || email || subject || helpMessage) {
      setFormValues({
        firstName: "",
        lastName: "",
        email: "",
        subject: "",
        helpMessage: "",
      });
    } else {
      navigate("/aboutus");
    }
  };

  const handleSendContactEmail = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(
        `/operator/send_contactus/`,
        formValues
      );
      if (response.status === 200) {
        setIsConfirmationOpen(true);
        setFormValues({
          firstName: "",
          lastName: "",
          email: "",
          subject: "",
          helpMessage: "",
        });
      } else {
        setErrorMessage(
          `Failed to send contact us info. Status: ${response.status}`
        );
        setIsErrorOpen(true);
      }
    } catch (error) {
      setErrorMessage(
        "An error occurred while sending contact us info. Please try again."
      );
      setIsErrorOpen(true);
      console.error("Error sending contact us info:", error);
    }
  };
  return (
    <div className="page-body">
      <NavBar />
      <div className=".rectangle-patient-register top-right"></div>
      <div className=".rectangle-patient-register bottom-right"></div>
      <div className=".rectangle-patient-register bottom-circle"></div>
      <div className="contact-us-main" style={{ zIndex: 1 }}>
        <div className="center-rectangle">
          <div className="contact-form">
            <h2>Send Us A Message</h2>
            <form
              className="form-group-contact"
              onSubmit={handleSendContactEmail}
            >
              <div className="form-group-line-1">
                <input
                  type="text"
                  name="firstName"
                  value={formValues.firstName}
                  placeholder={"First name"}
                  onChange={handleChange}
                  className="firstname-form"
                  // disabled
                />
                <input
                  type="text"
                  name="lastName"
                  value={formValues.lastName}
                  placeholder={"Last name"}
                  onChange={handleChange}
                  className="firstname-form "
                  // disabled
                />
              </div>

              <input
                type="email"
                name="email"
                value={formValues.email}
                placeholder={"Email"}
                onChange={handleChange}
                className="firstname-form"
                // disabled
              />
              <input
                type="text"
                name="subject"
                value={formValues.subject}
                onChange={handleChange}
                placeholder="Subject"
                className="firstname-form"
                required
              />

              <textarea
                name="helpMessage"
                className="firstname-form"
                value={formValues.helpMessage}
                onChange={handleChange}
                placeholder="How can we help?"
                required
              ></textarea>
              <div className="contactus-buttons">
                <button type="submit" className="contact-button">
                  Send
                </button>
                <button
                  type="cancel"
                  className="contact-button"
                  onClick={handleCancel}
                >
                  Cancel
                </button>
              </div>
            </form>
          </div>
          <div className="contact-info">
            <div className="contact-title">Contact Information</div>
            <div className="map-contact">
              <img src={Location} alt="Location" />
              <p>2 Bryant St, Suite 240, San Francisco CA, 94105</p>
            </div>
            <div className="map-contact">
              <img src={Mail} alt="Mail" />
              <p>hello@neuro42.com</p>
            </div>
            <div className="map-contact">
              <img src={Call} alt="Call" />
              <p>(480)-241-3211</p>
            </div>
            <div className="social-media">
              <a
                href="https://www.instagram.com/neuro42inc/"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="social-img" src={insta} alt="insta" />
              </a>
              <a
                href="https://x.com/i/flow/login?redirect_after_login=%2Fneuro42inc"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="social-img" src={twitter} alt="twitter" />
              </a>
              <a
                href="https://www.linkedin.com/company/neuro42"
                target="_blank"
                rel="noopener noreferrer"
              >
                <img className="social-img" src={linkedin} alt="linkedin" />
              </a>
            </div>
          </div>
        </div>
      </div>
      {/* Confirmation Modal */}
      {isConfirmationOpen && (
        <div
          className="confirmation-modal-overlay"
          role="dialog"
          data-testid="confirmation-modal"
        >
          <div className="confirmation-modal-content">
            <div className="confirmation-modal-header">
              <img src={tick} alt="Character" className="check-image" />
            </div>
            <h2>Thank You!</h2>
            <p>
              Your message has been sent successfully. We will review your
              request soon.
            </p>
            <button onClick={handleConfirmationClose}>Okay</button>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {isErrorOpen && (
        <div className="error-modal-overlay">
          <div className="error-modal-content">
            <div className="error-modal-header">
              <img src={cross} alt="Character" className="cross-image" />
              {/* <button className="modal-close-button" onClick={handleErrorClose}>
                                &times;
                            </button> */}
            </div>
            <h2>Oh Snap!</h2>
            <p>{errorMessage}</p>
            <div className="error-modal-actions">
              <button className="error-ok-button" onClick={handleErrorClose}>
                Ok
              </button>
            </div>
          </div>
        </div>
      )}
      {/* Confirmation Modal */}
      {isConfirmationOpen && (
        <div className="confirmation-modal-overlay">
          <div className="confirmation-modal-content">
            <div className="confirmation-modal-header">
              <img src={tick} alt="Character" className="check-image" />
            </div>
            <h2>Thank You!</h2>
            <p>
              Your message has been sent successfully. We will review your
              request soon.
            </p>
            <button onClick={handleConfirmationClose}>Okay</button>
          </div>
        </div>
      )}

      {/* Error Modal */}
      {isErrorOpen && (
        <div className="error-modal-overlay">
          <div className="error-modal-content">
            <div className="error-modal-header">
              <img src={cross} alt="Character" className="cross-image" />
              {/* <button className="modal-close-button" onClick={handleErrorClose}>
                                &times;
                            </button> */}
            </div>
            <h2>Oh Snap!</h2>
            <p>{errorMessage}</p>
            <div className="error-modal-actions">
              <button className="error-ok-button" onClick={handleErrorClose}>
                Ok
              </button>
            </div>
          </div>
        </div>
      )}

      <Footer />
    </div>
  );
};

export default ContactUsLanding;
